import { HttpErrorResponse } from '@angular/common/http';

/**
 * Extract a server-supplied error message from an HTTP failure. Admin
 * endpoints reject with either a class-validator DTO rejection
 * (`message: string[]`) or a structured `{ message, code }` body
 * (BadRequestException/ConflictException), so the user sees the SPECIFIC
 * reason a call failed instead of one generic string for every kind of
 * failure. Falls back to `fallback` for anything unstructured (network
 * error, a bare 500, etc).
 */
export function extractApiErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof HttpErrorResponse) {
    const message = (error.error as { message?: unknown } | null)?.message;
    if (typeof message === 'string' && message.trim().length > 0) {
      return message;
    }
    if (Array.isArray(message)) {
      const parts = message.filter((part): part is string => typeof part === 'string' && part.trim().length > 0);
      if (parts.length > 0) {
        return parts.join('; ');
      }
    }
  }
  return fallback;
}
